import React from 'react'
import {CustomModal} from './Modal'

const FinancialSupportAlertModal = props => {
  return (
    <CustomModal className={`modal ${props.className}`} isOpen={props.isOpen} handleCloseModal={() => props.handleCloseModal()}>
      <div className="financial-modal-content">
        <p>Please accept your CSP and complete the {props.feeType} form to proceed.</p>
        <p>
          If you need assistance, please contact us on 9919 6100 or through{' '}
          <a href={props.enquireLink} target="_blank">
            Enquire Now function
          </a>{' '}
          - more info{' '}
          <a href={props.contactLink} target="_blank">
            here
          </a>
        </p>
        <div className="row">
          <div className="col-xs-12 center">
            <button className="btn btn-financial-sm btn-primary" onClick={() => props.handleCloseModal()}>
              OK
            </button>
          </div>
        </div>
      </div>
    </CustomModal>
  )
}
export default FinancialSupportAlertModal
